// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithPopup,
  getRedirectResult,
  GoogleAuthProvider,
  GithubAuthProvider,
} from "firebase/auth";
export class authHelper {
  auth;
  provider;
  app;
  analytics;

  constructor() {
    const firebaseConfig = {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_FIREBASE_APP_ID,
    };
    // Initialize Firebase
    this.app = initializeApp(firebaseConfig);
    this.auth = getAuth();
  }

  async authenticateWithGoogle() {
    try {
      this.provider = new GoogleAuthProvider();
      const data = await signInWithPopup(this.auth, this.provider);
      const user = data.user;
      if (user) {
        return {
          uid: user.uid,
          displayName: user.displayName,
          email: user.email,
          photoURL: user.photoURL,
        };
      }
      return null;
    } catch (error) {
      console.error("Error during Google sign-in:", error);
      throw new Error(`Google sign-in failed: ${error.message}`);
    }
  }

  async authenticateWithGitHub() {
    try {
      this.provider = new GithubAuthProvider();
      const data = await signInWithPopup(this.auth, this.provider);
      const user = data.user;
      if (user) {
        return {
          uid: user.uid,
          displayName: user.displayName,
          email: user.email,
          photoURL: user.photoURL,
        };
      }
      return null;
    } catch (error) {
      console.error("Error during Github sign-in:", error);
      throw new Error(`Github sign-in failed: ${error.message}`);
    }
  }

  async signOut() {
    return this.auth
      .signOut()
      .then(() => {
        console.log("User signed out");
      })
      .catch((error) => {
        console.error("Sign out error:", error);
        throw new Error(`Sign out failed: ${error.message}`);
      });
  }

  async getCurrentUser() {
    try {
      const user = this.auth.currentUser;
      if (user) {
        return {
          uid: user.uid,
          displayName: user.displayName,
          email: user.email,
          photoURL: user.photoURL,
        };
      } else {
        console.log("No user is currently signed in.");
      }
    } catch (error) {
      console.error("Error getting current user:", error);
      throw new Error(`Failed to get current user: ${error.message}`);
    }
  }
}

// I need to authenticate user with google
// write a code to authenticate user with google using firebase auth
